export type OnboardingScreen =
  'intro' | 'person' | 'install' | 'link' | 'recordings' | 'agent' | 'done' | 'dashboard';

export const ONBOARDING_SCREENS = ['intro', 'person', 'install', 'link', 'recordings', 'agent'] as const;

/** Older links (emails, sidebar, help) keep working after the steps were split up. */
const aliases: Partial<Record<string, OnboardingScreen>> = {
  phone: 'person',
  phones: 'person',
  team: 'person',
  verify: 'link',
  test: 'link',
  sync: 'link',
  recording: 'recordings',
  chatgpt: 'agent',
};

export function resolveOnboardingScreen(
  requested: string | null,
  resume: OnboardingScreen,
  state: { hasPerson: boolean; connected: boolean; hasCall: boolean; complete: boolean },
): OnboardingScreen {
  let screen = aliases[requested || ''] || requested;
  // “connect” used to mean install + pairing; send people to whichever part is still open.
  if (screen === 'connect') screen = state.connected ? 'link' : 'install';
  if (screen === 'complete') return state.complete ? 'dashboard' : resume;
  if ((screen === 'install' || screen === 'link') && !state.hasPerson) return 'person';
  if (screen === 'recordings' && !state.connected) return state.hasPerson ? 'install' : 'person';
  if (screen === 'done') return state.complete ? 'dashboard' : resume;
  if (screen === 'agent') return screen;
  return (ONBOARDING_SCREENS as readonly string[]).includes(screen || '')
    ? (screen as OnboardingScreen)
    : resume;
}
